import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { ReactNode } from 'react';
import GeoMobyBaseTheme from '../Style/GeoMobyBaseTheme';

export const Themed = ({ children }: { children: ReactNode }) => (
  <ThemeProvider theme={GeoMobyBaseTheme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);
